import { Children, FunctionComponent, useEffect, useRef, useState, } from 'react';
import * as styles from './ScrollSnap.css';
import * as T from './ScrollSnap.types';
import ArrowPrev from '@paradigm/icons/src/mailru/navigation/drop_previous_big.svg';
import ArrowNext from '@paradigm/icons/src/mailru/navigation/drop_next_big.svg';
import classNames from 'classnames';
import debounce from '@media-ui/core/src/utils/debounce';
const ScrollSnap: FunctionComponent<T.ScrollSnapProps> = ({ className, classNameItem, dataQa, children, showPrevArrow = false, showNextArrow = true, }) => {
    const scrollContainer = useRef<HTMLDivElement>(null);
    const [arrowsVisibility, setArrowsVisibility] = useState({
        prev: showPrevArrow,
        next: showNextArrow,
    });
    const scrollHandler = debounce((event: any) => {
        const scrollChildren = event.target && (event.target.firstElementChild as HTMLUListElement);
        if (event.target && scrollChildren) {
            // Пытаемся перемотать до начала трека
            if (event.target.scrollLeft < 0) {
                return;
            }
            // Перемотали на самое начало
            if (event.target.scrollLeft === 0) {
                setArrowsVisibility({
                    prev: false,
                    next: true,
                });
                // Промотали в конец
            }
            else if (scrollChildren.scrollWidth - event.target.scrollLeft <=
                event.target.offsetWidth) {
                setArrowsVisibility({
                    prev: true,
                    next: false,
                });
            }
            else {
                // Листаем трек где-то между началом и концом
                setArrowsVisibility({
                    prev: true,
                    next: true,
                });
            }
        }
    }, 200);
    useEffect(() => {
        const scrollContainerCurrent = scrollContainer.current;
        if (!scrollContainerCurrent) {
            return;
        }
        scrollContainerCurrent.addEventListener('scroll', scrollHandler, {
            passive: true,
        });
        return () => {
            scrollContainerCurrent.removeEventListener('scroll', scrollHandler);
        };
    });
    const slides = Children.map(children, (child, index) => {
        return (<li className={classNames(styles.item, classNameItem)} key={`scroll-snap-child-${index}`}>
        {child}
      </li>);
    });
    if (!slides) {
        return null;
    }
    const moveSlider = (direction: number, position?: number) => {
        const containerEl = scrollContainer.current;
        if (!containerEl) {
            return;
        }
        const leftScrollPosition = typeof position === 'number'
            ? position
            : containerEl.scrollLeft + containerEl.offsetWidth * direction;
        containerEl.scrollTo({
            behavior: 'smooth',
            left: leftScrollPosition,
        });
    };
    const controlBase = classNames(styles.control, styles.controlAbsolute);
    const controlNext = classNames(controlBase, styles.controlNext);
    const controlPrev = classNames(controlBase, styles.controlPrev);
    return (<div className={styles.root} data-qa={dataQa}>
      {arrowsVisibility.prev && (<button className={controlPrev} onClick={() => moveSlider(-1)}>
          <ArrowPrev className={styles.icon}/>
        </button>)}
      <div ref={scrollContainer} className={classNames(className, styles.scrollDirection)}>
        <ul className={styles.listReset}>{slides}</ul>
      </div>
      {arrowsVisibility.next && (<button className={controlNext} onClick={() => moveSlider(1)}>
          <ArrowNext className={styles.icon}/>
        </button>)}
    </div>);
};
export default ScrollSnap;
